export enum BuiltInDictionaryParamType {
  TIME_WORKER_ID = 0,
}
